var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.229 11.377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.779 1.367H5.43L4.628.307h8.15zm0 8.595c0 .631-.514 1.145-1.145 1.145H1.576A1.146 1.146 0 01.431 9.962V.308h3.754l1.07 1.412h7.524zM.079-.045V9.962a1.5 1.5 0 001.497 1.498h10.058a1.5 1.5 0 001.498-1.498V-.045z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6 4.255h-.722v.642H3.6zM3.6 5.572H2.467V6l.439.082v1.965l-.414.083v.424h1.519V8.13l-.41-.083zM11.005 6.69h-5.2v.353h5.2zM9.504 8.184H5.806v.353h3.698zM11.005 5.25h-5.2v.353h5.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderInfo);
export default __webpack_public_path__ + "static/media/folder-info.54a4c028.svg";
export { ForwardRef as ReactComponent };